const tables = [
  {
    name: "Number",
  },
  {
    name: "Supplier",
  },
  {
    name: "Date",
  },
  {
    name: "Due",
  },
  {
    name: "Status",
  },
  {
    name: "Amount",
  },
  {
    name: "Action",
  },
];

export default tables;
